const endSlash = new RegExp('/$');
const startSlash = new RegExp('^/');

/**
 * Joins two parts of a URL path together, ensuring there is only one
 * '/' between parts.
 * @arg base Used as the base path of the joined URL (the left side). Can be either a string or a
 *      URL object.
 * @arg left Used as the path to combine with the base URL path (the right side).
 * @returns a string that represents the joined paths.
 */
export function joinURLPath(base: string | URL, leaf: string): string {
  const basePath = base instanceof URL ? base.pathname : base;
  if (endSlash.test(basePath)) {
    if (startSlash.test(leaf)) {
      return `${basePath}${leaf.substr(1)}`;
    }

    return `${basePath}${leaf}`;
  }

  if (startSlash.test(leaf)) {
    return `${basePath}${leaf}`;
  }

  return `${basePath}/${leaf}`;
}
